import { GETCUSTPMERAPPOINMETREPORT, GETCUSTPMERAPPOINMETREPORTXLSX } from "../../../utils/api"
import axios from "../../../utils/axios"

export const getAppoinment= async(payload,callback)=>{
    await axios.post(GETCUSTPMERAPPOINMETREPORT,payload)    .then((res)=>{
        callback(res?.data)
    }).catch((err)=>{
        console.log("err ",err)
    })
}

export const getAppointmentXlsx = async(params,options)=>{
    const res = await axios.post(GETCUSTPMERAPPOINMETREPORTXLSX,params,options);

    return res;
}